import productReturns from './productReturns'

export default productReturns
